import { CONFIG_BLOCK_GETS, CONFIG_BLOCK_PAGE_REFRESH, CONFIG_BLOCK_SUBDIVISION_GETS } from './block.types';

export const initState = {
  data: [],
  totalData: 0,
  subdivisions: [],
};

const block = (state = initState, action) => {
  switch (action.type) {
    case CONFIG_BLOCK_PAGE_REFRESH: {
      return {
        ...initState,
      };
    }
    case CONFIG_BLOCK_GETS.SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        totalData: action.payload.totalRecord,
      };
    }
    case CONFIG_BLOCK_SUBDIVISION_GETS.SUCCESS: {
      return {
        ...state,
        subdivisions: action.payload.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default block;
